import React from 'react';
import { Box, Typography } from '@mui/material';

const truncate = (s, n) => (s && s.length > n ? `${s.slice(0, n - 1).trimEnd()}…` : s || '');

// Google-style search result snippet. Shows how the page's title + description
// will render in results, using the same fallbacks the server applies. This is
// the primary "preview" for SEO metadata in Phase 1.
export default function SerpPreview({ path = '/', title, description }) {
  const displayTitle = truncate(title || 'Page title', 60);
  const displayDesc = truncate(description || 'Meta description preview…', 160);
  const crumb = `jethl.com${path === '/' ? '' : ` › ${path.replace(/^\//, '').split('/').join(' › ')}`}`;

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2, bgcolor: 'background.paper', maxWidth: 600 }}>
      <Typography variant="caption" sx={{ color: '#202124' }}>{crumb}</Typography>
      <Typography sx={{ color: '#1a0dab', fontSize: 20, lineHeight: 1.3, mt: 0.25, '&:hover': { textDecoration: 'underline' } }}>
        {displayTitle}
      </Typography>
      <Typography sx={{ color: '#4d5156', fontSize: 14, mt: 0.5 }}>
        {displayDesc}
      </Typography>
    </Box>
  );
}
